import { render, staticRenderFns } from "./BSimCard.vue?vue&type=template&id=a93e85dc&"
import script from "./BSimCard.vue?vue&type=script&lang=js&"
export * from "./BSimCard.vue?vue&type=script&lang=js&"
import style0 from "./BSimCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports